import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtErr } from "../lib/api";
import { Mail, MoonStar } from "lucide-react";

export default function RecuperaPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="recupera-page">
      <div className="mystic-card p-8 sm:p-10">
        <div className="text-center mb-8">
          <MoonStar className="w-8 h-8 text-amber-400 mx-auto mb-3" />
          <h1 className="font-display text-3xl text-amber-100">Recupera password</h1>
        </div>
        {done ? (
          <div className="text-center space-y-5" data-testid="recupera-success">
            <Mail className="w-10 h-10 text-amber-400/70 mx-auto" />
            <p className="text-purple-100/85 text-sm leading-relaxed">
              Se questo indirizzo è associato a un account, riceverai a breve un'email con il link per
              reimpostare la password. Il link è valido 1 ora e può essere usato una sola volta.
            </p>
            <p className="text-purple-300/50 text-xs">Controlla anche la cartella dello spam.</p>
            <Link to="/accedi" data-testid="recupera-back-login" className="inline-block text-xs text-amber-300/80 hover:text-amber-200 underline underline-offset-2 transition-colors">
              Torna ad Accedi
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-purple-200/70 text-sm leading-relaxed">
              Inserisci l'indirizzo email associato al tuo account: ti invieremo un link sicuro per
              reimpostare la password.
            </p>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              data-testid="recupera-email-input"
              className="input-dark"
            />
            {error && <p className="text-red-400 text-sm" data-testid="recupera-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="recupera-submit-btn" className="gold-btn w-full py-3 text-sm disabled:opacity-60">
              {busy ? "Invio in corso…" : "Invia il link di recupero"}
            </button>
            <div className="text-center">
              <Link to="/accedi" data-testid="recupera-back-login" className="text-xs text-purple-300/60 hover:text-amber-200 transition-colors">
                Torna ad Accedi
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
